<template>
    <div class="">
        <div class="login-body py-3">
            <div class="d-flex justify-content-center align-items-center" style="height:100vh;">
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm text-center">
                        <div class="card-body px-lg-5 py-5">
                            <h5 class="font-weight-bold pb-4">MoneyPool Login</h5>
                            <form @submit.prevent="login()">
                                <div class="form-group mb-3 align-items-center justify-content-center">
                                    <!-- <label for="username" class="col-md-3 text-muted"> </label> -->
                                    <input class="form-control py-2 col-md-12 form-control-lg" v-model="form.email" placeholder="Email/Username" type="text" required autofocus>
                                </div>
                                <div class="form-group mb-4 align-items-center justify-content-center">
                                    <!-- <label for="password" class="col-md-3 text-muted"> </label> -->
                                    <input class="form-control form-control-lg py-2 col-md-12" v-model="form.password" placeholder="Password" type="password"  required>
                                </div>
                                <div class="d-md-flex text-left">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input" id="customCheck" name="example1">
                                            <label class="custom-control-label text-muted" for="customCheck">Remember me</label>
                                        </div>
                                    </div>

                                    <div class="ml-auto mb-3">
                                        <router-link :to="{ name: 'reset-password'}">Forgot Password?</router-link>
                                    </div>
                                </div>
                                
                                <div class="">
                                    <div class="m-0 p-0">
                                        <button class="btn btn-custom btn-block btn-lg mb-3" type="submit">Login</button>
                                        <div class="mb-4" style="width: 100%;">
                                            <a class="btn btn-block btn-danger  text-white"
                                                ref="signinBtn">
                                                <span class="fab fa-google" style="font-size: 15px; padding: 8px;"></span> 
                                                    Sign in with Google
                                            </a>
                                        </div>
                                        <p class="h6 font-weight-normal">Get a free account today. 
                                            <router-link to="/signup" exact>Signup</router-link>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="d-flex mt-2 justify-content-center">
                        <p class="mr-3 ft-16">
                            <a class="text-muted btn btn-link" href="/">Home</a>
                        </p>
                        <p class="mr-3 ft-16">
                            <a class="text-muted btn btn-link" href="">Terms</a>
                        </p>
                        <p class="mr-3 ft-16">
                            <a class="text-muted btn btn-link" href="">Privacy Policy </a>
                        </p>
                        <p class="ft-16">
                            <a href="" class="text-muted btn btn-link"> Help</a>
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {
            form: {
                email: '',
                password: ''
            }
        }
    },

    beforeDestroy() {
        if (document.querySelector("meta[name=google-signin-client_id]")) {

            document.querySelector("meta[name=google-signin-client_id]").remove()
        }
    },
    mounted() {
        const meta_element = document.createElement('meta');
        meta_element.setAttribute('name', 'google-signin-client_id');
        meta_element.setAttribute('content', process.env.VUE_APP_GOOGLE_CLIENTID);
        document.head.appendChild(meta_element);
        
        window.gapi.load('auth2', () => {
            const auth2 = window.gapi.auth2.init();

            auth2.attachClickHandler(this.$refs.signinBtn, {}, googleUser => {
                this.signinWithGoogle(googleUser)
            }, error => console.log(error))
        });
    },
    methods: {
        async signinWithGoogle(googleUser) {
            const profile = googleUser.getBasicProfile();
            const { Eea, wea, ofa, U3 } = profile;
            const social = {
                social_id: Eea, 
                firstname: ofa,
                lastname: wea,
                email: U3
            };

            try {
                const googleLogin = await axios.post('/auth/social/google/onboard', social);
    
                if (googleLogin.status == 200) {
    
                    const { access_token, expires_in, token_type } = googleLogin.data;
                    const headers = { Authorization: `Bearer ${access_token}`};
                    const logged_in_user = await axios.post('/auth/me', {}, { headers });
    
                    localStorage.setItem('access_token', access_token);
                    localStorage.setItem('expires_in', expires_in);
                    localStorage.setItem('token_type', token_type);
                    localStorage.setItem('user', JSON.stringify(logged_in_user.data));

                    // this.$router.push('/dashboard');
                    window.location.href = "/dashboard"

                    // set axios authorization header
                    axios.defaults.headers.Authorization = `Bearer ${access_token}`;
                }            
            } catch (error) {
                // console.log(error.response)
            }
        },

        async login() {
            try {
                const user = await axios.post('/auth/login', this.form);

                // check: if user is not null 
                const { access_token, expires_in, token_type } = user.data;

                localStorage.setItem('access_token', access_token);
                localStorage.setItem('expires_in', expires_in);
                localStorage.setItem('token_type', token_type);

                const headers = { Authorization: `Bearer ${access_token}`};

                const logged_in_user = await axios.post('/auth/me', {}, { headers });
                
                if (logged_in_user.status == 200) {
                    localStorage.setItem('user', JSON.stringify(logged_in_user.data));

                    // this.$router.push('/dashboard'); 
                    window.location.href = "/dashboard"

                    // set axios authorization header
                    axios.defaults.headers.Authorization = `Bearer ${access_token}`;                
                }
            } catch (error) {
                // console.log(error.response);
            }
        },
    }

}
</script>

<style>
.login-body {
    padding: 0;
    margin: 0;
    background: #F4EEF6;
    /* height: 100vh; */
    /* background: url('../assets/background.png'); */
    /* background-repeat: no-repeat; */
    /* background-size: cover; */
}
.card {
    background-color: #ffffffdb;
}
.ft-16 {
    font-size: 16px;
}

</style>